module.exports = __webpack_public_path__ + "static/hats2-0cc99263c9dbbe7d164f33e450429e28.jpeg";